import React, { useContext } from 'react'

import { useTranslation } from 'react-i18next'

import Tooltip from '@components/shared/Tooltip'
import { TitleContext } from '@providers/TitleProvider'

import DetailsSection from './DetailsSection'
import Favorites from './Favorites'
import Share from './Share'
import Views from './Views'

const Social: React.FC = () => {
  const { title } = useContext(TitleContext)
  const { t } = useTranslation()

  return (
    <DetailsSection>
      <div className="flex flex-row justify-between px-2">
        <Tooltip content={t('label.favorite')} arrow placement="bottom">
          <span>
            <Favorites />
          </span>
        </Tooltip>
        <Tooltip content={t('label.views')} arrow placement="bottom">
          <span>
            <Views count={title?.views} />
          </span>
        </Tooltip>
        <Tooltip content={t('label.share')} arrow placement="bottom">
          <span>
            <Share />
          </span>
        </Tooltip>
      </div>
    </DetailsSection>
  )
}

export default Social
